import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import PublicLayout from './layouts/PublicLayout';
import EstimationLayout from './layouts/EstimationLayout';

const Landing = lazy(() => import('./pages/Landing'));
// Tunnel v2 « plaque d'abord » (test lead-gen 11/07/26).
// Les anciennes pages TunnelStep1/2/3 + Result restent dans le repo (rollback).
const QuickPlate = lazy(() => import('./pages/QuickPlate'));
const QuickContact = lazy(() => import('./pages/QuickContact'));
const QuickAnalyse = lazy(() => import('./pages/QuickAnalyse'));
const QuickResult = lazy(() => import('./pages/QuickResult'));
const QuickBooking = lazy(() => import('./pages/QuickBooking'));
const VehiculeIntrouvable = lazy(() => import('./pages/VehiculeIntrouvable'));
const Booking = lazy(() => import('./pages/Booking'));
const BookingConfirm = lazy(() => import('./pages/BookingConfirm'));
const BookingManage = lazy(() => import('./pages/BookingManage'));
const VehicleDetail = lazy(() => import('./pages/VehicleDetail'));
const Legal = lazy(() => import('./pages/Legal'));
const Privacy = lazy(() => import('./pages/Privacy'));
const NotFound = lazy(() => import('./pages/NotFound'));

export default function App() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-primary-bg" />}>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/vehicule/:id" element={<VehicleDetail />} />
          <Route path="/mentions-legales" element={<Legal />} />
          <Route path="/confidentialite" element={<Privacy />} />
        </Route>
        <Route element={<EstimationLayout />}>
          <Route path="/estimation" element={<QuickPlate />} />
          <Route path="/estimation/coordonnees" element={<QuickContact />} />
          <Route path="/estimation/analyse" element={<QuickAnalyse />} />
          <Route path="/estimation/resultat" element={<QuickResult />} />
          <Route path="/estimation/rdv" element={<QuickBooking />} />
          <Route path="/estimation/introuvable" element={<VehiculeIntrouvable />} />
          {/* Legacy : liens /rdv?lead=... présents dans les emails déjà envoyés. */}
          <Route path="/rdv" element={<Booking />} />
          <Route path="/rdv/confirmation" element={<BookingConfirm />} />
          <Route path="/rdv/gestion" element={<BookingManage />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
